// HyperMD / CodeMirror の遅延ロード
// auth ready 時に一度だけロードする

let loaded = false;

const load = () => {
  if (loaded) return;

  let hypermd = require('hypermd');
  let codemirror = require('codemirror');

  require('codemirror/mode/javascript/javascript');
  require('codemirror/mode/yaml/yaml');
  require('codemirror/mode/clike/clike');

  require('codemirror/addon/hint/show-hint.js');
  require('codemirror/addon/display/placeholder.js');
  require('codemirror/addon/search/searchcursor.js');

  global.HyperMD = hypermd;
  global.CodeMirror = codemirror;

  // mermaid のレンダラーを登録
  let app = require('./app').default;
  app.mermaid.setup(hypermd);

  loaded = true;
};

export default { load };
